/* Small per-device UI preferences.

   These are conveniences, not collection data, so they live in localStorage
   rather than the database: no round trip, and nothing to reconcile if two
   devices disagree. Every access is guarded — a browser in private mode, or
   with site data blocked, throws on the accessor itself rather than returning
   null, and a preference is never worth breaking a screen over. */

const PREFIX = "senogara:";

export function readPref(key, fallback) {
  try {
    return window.localStorage.getItem(PREFIX + key) ?? fallback;
  } catch {
    return fallback;
  }
}

export function writePref(key, value) {
  try {
    window.localStorage.setItem(PREFIX + key, value);
  } catch {
    // Nothing to do and nothing worth telling the user: the choice simply
    // won't survive a reload.
  }
}
